"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sumItemsFromProps = void 0;
const sumItemsFromProps = _ref => {
  let {
    image360,
    images,
    videos
  } = _ref;
  let totalItemCount = image360 ? 1 : 0;
  images && (totalItemCount += images.length);
  videos && (totalItemCount += videos.length);
  return totalItemCount;
};
exports.sumItemsFromProps = sumItemsFromProps;
//# sourceMappingURL=sumItemsFromProps.js.map